import { reactive, ref } from 'vue'
import axios from '@/axios'

const isOpen = ref(false)
const status = ref(-1)
const type = ref('')
const isImgPreviewOpen = ref(false)
const imgPreviewType = ref('')
const imgPreviewIndex = ref()
const imgPreviewIsTemporary = ref('')

const isChildOpen = ref(false)

const currentImgPreview = reactive({
  normalImage: null,
  blackImage: null,
})

export const useDialog = () => {
  const closeDialog = () => {
    isOpen.value = false
    status.value = -1
    type.value = ''
  }

  const openDialog = val => {
    isOpen.value = true
    status.value = 0
    type.value = val
  }

  const openChildDialog = () => {
    isChildOpen.value = true
  }

  const closeChildDialog = () => {
    isChildOpen.value = false
  }

  const openNewDialog = () => {
    isOpen.value = true
    status.value = 2
  }

  const openImgPreview = (type, index, img, temporary) => {
    isImgPreviewOpen.value = true
    imgPreviewType.value = type
    imgPreviewIndex.value = index
    imgPreviewIsTemporary.value = temporary === 'temporary'
    if (img.blackImage == null) {
      img.blackImage = img.normalImage
    }
    currentImgPreview.value = img
  }

  const closeImgPreview = () => {
    isImgPreviewOpen.value = false
  }

  /**
   * 黒塗りイメージを保存する
   *
   * @param {number} activityId political_actions.id
   *
   */
  const putBlackImage = (
    type,
    activityId,
    imageData,
    keepFileNames,
    receiptId,
  ) => {
    if (type == 'request') {
      axios.put(`/actions/image/${activityId}`, {
        application_images: imageData,
        keep_file_names: keepFileNames,
      })
    }
    if (type == 'result') {
      axios.put(`/actions/image/${activityId}`, {
        report_images: imageData,
        keep_file_names: keepFileNames,
      })
    }
    if (type == 'memory') {
      axios.put(`/actions/image/${activityId}`, {
        memory_images: [
          {
            receipt_id: receiptId ? receiptId : null,
            images: imageData,
          },
        ],
        keep_file_names: keepFileNames,
      })
    }
    if (type == 'receipt') {
      axios.put(`/receipts/image/${activityId}`, {
        images: imageData,
        keep_file_names: keepFileNames,
      })
    }
  }

  return {
    isOpen,
    isImgPreviewOpen,
    currentImgPreview,
    status,
    type,
    imgPreviewType,
    imgPreviewIndex,
    imgPreviewIsTemporary,
    closeDialog,
    openDialog,
    openNewDialog,
    isChildOpen,
    openChildDialog,
    closeChildDialog,
    openImgPreview,
    closeImgPreview,
    putBlackImage,
  }
}
